var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "button",
    class: _vm.classes,
    attrs: {
      "tabindex": _vm.tabIndex,
      "aria-label": _vm.accessibilityLabel,
      "aria-selected": _vm.selected,
      "aria-disabled": _vm.disabled,
      "role": "gridcell"
    },
    on: {
      "focus": _vm.onFocus,
      "mouseover": _vm.handleHover,
      "click": _vm.handleClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.dayNumber) + "\n")])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d71fdd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d71fdd1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisDatePickerDay.vue
// module id = 274
// module chunks = 0